import { useState } from "react";
import { Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import { openAppDownload } from "../../config/site";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  NavLinks,
  NavLink,
  HeaderInner,
} from "./styles";

const navItems = [
  { label: "Home", id: "intro" },
  { label: "Features", id: "features" },
  { label: "How It Works", id: "how-it-works" },
  { label: "About Us", id: "about" },
  { label: "Marketplace", id: "marketplace" },
];

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setVisibility(false);
  };

  const MenuItem = () => (
    <CustomNavLinkSmall>
      <Button variant="primary" onClick={openAppDownload}>
        {t("Get the App")}
      </Button>
    </CustomNavLinkSmall>
  );

  return (
    <HeaderSection>
      <Container>
        <HeaderInner>
          <LogoContainer aria-label="MyDealCase homepage" onClick={() => scrollTo("intro")}>
            <SvgIcon src="logo.svg" alt="MyDealCase" width="140px" height="auto" />
          </LogoContainer>
          <NotHidden>
            <NavLinks>
              {navItems.map((item) => (
                <NavLink key={item.id} onClick={() => scrollTo(item.id)}>
                  {item.label}
                </NavLink>
              ))}
            </NavLinks>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </HeaderInner>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          {navItems.map((item) => (
            <NavLink
              key={item.id}
              onClick={() => scrollTo(item.id)}
              style={{ display: "block", marginBottom: "1rem" }}
            >
              {item.label}
            </NavLink>
          ))}
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
